import { useTranslation } from 'react-i18next';
import CrossedEyeIcon from 'assets/img/icons/crossed-eye.svg?react';
import OpenedEyeIcon from 'assets/img/icons/opened-eye.svg?react';
import classNames from 'classnames';
import ButtonLoadingIcon from 'components/atoms/icons/buttonLoadingIcon';
import { usePatientActivity } from 'infrastructure/providers/patient-activity-context';

import s from './styles.module.scss';

import type { Nullable } from 'infrastructure/types';
import type { FC } from 'react';

interface Props {
  onClick: () => void;
  isOpen: boolean;
  isErroneous?: Nullable<boolean>;
  isLoading: boolean;
  disabled?: boolean;
}

const ErroneousButton: FC<Props> = ({
  onClick,
  isOpen,
  isErroneous,
  isLoading,
  disabled,
}) => {
  const { t } = useTranslation();
  const { onActivity } = usePatientActivity();

  const erroneousIcon = isErroneous ? (
    <OpenedEyeIcon width={24} height={24} />
  ) : (
    <CrossedEyeIcon width={22} height={22} />
  );

  return (
    <button
      className={classNames(s['erroneous-button'], {
        [s.highlight]: isOpen,
        [s.absolute]: !isErroneous,
      })}
      title={
        isErroneous
          ? t('labels.unMarkReadingAsErroneous')
          : t('labels.markReadingAsErroneous')
      }
      onClick={() => {
        onActivity();
        onClick();
      }}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <ButtonLoadingIcon className={s['spin-loading-icon']} />
      ) : (
        erroneousIcon
      )}
    </button>
  );
};
export default ErroneousButton;
